import { sbaAxios } from "../utils/sbaAxios";
import { getAssetDocWidget,getDocbyActivityId,getDocdetailsbyDocumentId } from "../../config/apiConfig";
import {
  FETCH_DOC_BEGIN,
  FETCH_DOC_SUCCESS,
  FETCH_DOC_FAILURE,

  FETCH_MULTIPLEDOCS_BEGIN,
  FETCH_MULTIPLEDOCS_SUCCESS,
  FETCH_MULTIPLEDOCS_FAILURE,

  FETCH_DOCDETAILS_BEGIN,
  FETCH_DOCDETAILS_SUCCESS,
  FETCH_DOCDETAILS_FAILURE,
  
  } from '../constants/assetDocuments';


//Get Documents 
export const getAssetDocuments = (AssetId) => {

    return (dispatch) => {
        dispatch(fetchDocBegin());
        sbaAxios({
            url: `${getAssetDocWidget}${AssetId}`,
            method: 'get',
        })
            .then((repos) => {
                const doc = repos;
                //Add logic to format the DataItem if needed using map
                dispatch(fetchDocSuccess(doc));
                return doc;
            })
            .catch((error) => dispatch(fetchDocFailure(error)));
    };
  }
  export const fetchDocBegin = () => ({
    type: FETCH_DOC_BEGIN,
  });
  
  export const fetchDocSuccess = (assetDocuments) => ({
  
    type: FETCH_DOC_SUCCESS,
    payload: { assetDocuments },
  });
  
  
  export const fetchDocFailure = (errorMessage) => ({
    type: FETCH_DOC_FAILURE,
    payload: { errorMessage }
  });

  //Get Documents 
export const getMultipleDocs = (ActivityId) => {

  return (dispatch) => {
      dispatch(fetchMultipleDocBegin());
      sbaAxios({
          url: `${getDocbyActivityId}${ActivityId}`,
          method: 'get',
      })
          .then((repos) => {
              const multipledoc = repos;
              //Add logic to format the DataItem if needed using map
              dispatch(fetchMultipleDocSuccess(multipledoc));
              return multipledoc;
          })
          .catch((error) => dispatch(fetchMultipleDocFailure(error)));
  };
}
export const fetchMultipleDocBegin = () => ({
  type: FETCH_MULTIPLEDOCS_BEGIN,
});

export const fetchMultipleDocSuccess = (mutipleDocuments) => ({

  type: FETCH_MULTIPLEDOCS_SUCCESS,
  payload: { mutipleDocuments },
});


export const fetchMultipleDocFailure = (errorMessage) => ({
  type: FETCH_MULTIPLEDOCS_FAILURE,
  payload: { errorMessage }
});

 //Get Documents  Details
 export const getDocumentdetails= (DocumentId) => {

  return (dispatch) => {
      dispatch(fetchMultipleDocBegin());
      sbaAxios({
          url: `${getDocdetailsbyDocumentId}${DocumentId}`,
          method: 'get',
      })
          .then((repos) => {
              const DocDetails = repos;
              //Add logic to format the DataItem if needed using map
              dispatch(fetchDocdetailsSuccess(DocDetails));
              return DocDetails;
          })
          .catch((error) => dispatch(fetchDocdetailsFailure(error)));
  };
}
export const fetchDocdetailsBegin = () => ({
  type: FETCH_DOCDETAILS_BEGIN,
});

export const fetchDocdetailsSuccess = (documentDetails) => ({

  type: FETCH_DOCDETAILS_SUCCESS,
  payload: { documentDetails },
});


export const fetchDocdetailsFailure = (errorMessage) => ({
  type: FETCH_DOCDETAILS_FAILURE,
  payload: { errorMessage }
});